import { initializeApp } from "firebase/app";
import { getMessaging, getToken } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyBaJcEV_8r1zd8kxRN0-gJHwcBXe90sbek",
  authDomain: "smott-7c4ff.firebaseapp.com",
  projectId: "smott-7c4ff",
  storageBucket: "smott-7c4ff.appspot.com",
  messagingSenderId: "801310356204",
  appId: "1:801310356204:web:13c98b119588f61ac92bc9",
  measurementId: "G-FT0X29RT65",
};

function isIOS() {
  const browserInfo = navigator.userAgent.toLowerCase();

  if (browserInfo.match("iphone") || browserInfo.match("ipad")) {
    return true;
  }
  if (
    [
      "iPad Simulator",
      "iPhone Simulator",
      "iPod Simulator",
      "iPad",
      "iPhone",
      "iPod",
    ].includes(navigator.platform)
  ) {
    return true;
  }
  return false;
}

function requestPermission() {
  if (!isIOS) {
    Notification.requestPermission().then((permission) => {
      if (permission === "granted") {
        const app = initializeApp(firebaseConfig);

        const messaging = getMessaging(app);
        getToken(messaging, {
          vapidKey:
            "BEeIPJ0gjHxcYnu4GKgyYZLLLtOAI5E11HSUKyd60_Z-wQ4J5pf6JOHcBsUi7TXuVl-dp09DfHBUSB7l6qiFawQ",
        }).then((currentToken) => {
          if (currentToken) {
          } else {
          }
        });
      } else {
      }
    });
  } else {
  }
}

requestPermission();
